import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import IndexPage from 'flarum/forum/components/IndexPage';
import Select from 'flarum/common/components/Select';
import Button from 'flarum/common/components/Button';

import FreeResourceDirectoryList from './FreeResourceDirectoryList';
import FreeResourceDirectoryState from '../states/FreeResourceDirectoryState';

import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

/**
 * This page re-uses Flarum's IndexPage CSS classes
 */
export default class FreeResourceDirectoryPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);

    app.setTitle('Free Resources');
    app.setTitleCount(0);

    this.state = new FreeResourceDirectoryState({});

    this.state.refreshParams({
      // ...app.search.params(),
      ...{
        q: m.route.param('q'),
        type: m.route.param('type'),
      },
    });

    this.q = m.route.param('q');

    this.loading = false;

    this.bodyClass = 'FreeResourceDirectoryPage';

    app.history.push('free-resources', app.translator.trans('td-free-resources.forum.header.back_to_free_resources_directory_tooltip'));
  }

  view() {
    if (this.loading) {
      return LoadingIndicator.component();
    }

    return (
      <div className="IndexPage FreeResourceDirectory">
        {IndexPage.prototype.hero()}
        <div className="container FreeResourcesWrap">
          <div className="sideNavContainer">
            <nav>
              <div className="IndexPage-nav sideNav">
                <div>Filters:</div>
                <ul>{listItems(this.sidebarItems().toArray())}</ul>
              </div>
            </nav>
            <div className="IndexPage-results sideNavOffset">
              <div className="IndexPage-toolbar">
                {this.searchForm()}
              </div>
              <FreeResourceDirectoryList state={this.state} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Our own sidebar. Re-uses Index.sidebarItems as the base
   * Elements added here will only show up on the directory page
   *
   * @return {ItemList}
   */
  sidebarItems() {
    const items = new ItemList();

    const TypeFilter = this.state.TypeFilter();
    const type_options = {};
    for (const i in TypeFilter) {
      type_options[i] = app.translator.trans('td-free-resources.lib.type.' + i);
    }
    items.add(
      'type',
      Select.component({
        options: type_options,
        value: this.state.getParams().type || 'default',
        // onchange: this.changeParams.bind(this),
        onchange: (value) => {
          this.updateParams({ type: value });
        },
      }),
      100
    );

    return items;
  }

  /**
   * Our own sidebar navigation. Re-uses Index.navItems as the base
   * Elements added here will only show up on the directory page
   *
   * @return {ItemList}
   */
  navItems() {
    const items = IndexPage.prototype.navItems();
    const params = this.stickyParams();

    items.remove('allDiscussions');
    items.remove('following');
    items.remove('tags');
    items.remove('tag1');
    items.remove('separator');

    return items;
  }

  viewItems() {
    const items = new ItemList();

    return items;
  }

  searchForm() {
    return (
      <form onsubmit={this.onsubmit.bind(this)}>
        <div class="free-resources-search-form">
          <input
            className="input-search"
            name="q"
            value={this.q}
            oninput={(e) => (this.q = e.target.value)}
            placeholder="Search Resources..."
          ></input>
          <Button type="submit" className="btn-search" aria-label="Search">
            <i class="fas fa-search"></i>
          </Button>
        </div>
      </form>
    );
  }

  onsubmit(e) {
    e.preventDefault();
    this.updateParams({ q: this.q });
  }
  
  /**
   * Redirect to the index page using the given type parameter.
   *
   * @param {String} type
   */
  changeParams(type) {
    const params = this.params();

    if (type === 'default') {
      delete params.type;
    } else {
      params.type = type;
    }

    const routeParams = { ...params };
    delete routeParams.qBuilder;

    m.route.set(app.route('free_resources', routeParams));
  }

  updateParams(obj) {
    const params = this.params();

    let key = Object.keys(obj)[0];
    let value = obj[key];

    if (value === 'default' || value === '0') {
      delete params[key];
    } else {
      params[key] = value;
    }

    const routeParams = { ...params };
    delete routeParams.qBuilder;

    m.route.set(app.route('free_resources', routeParams));
  }

  stickyParams() {
    return {
      q: m.route.param('q'),
      type: m.route.param('type'),
    };
  }

  params() {
    return this.stickyParams();
  }
}
